import { Box, Link, VStack, Icon, Image, HStack } from '@chakra-ui/react'
import { FaCheck } from 'react-icons/fa6'
import { buildAssetUrlString, isBlank } from '@!/Util'
import { PaymentHeader, PageBackLink, CreditCardInfo } from '@!/User/Payment/components'
import MonthlySubmitButton from '@!/User/Payment/components/MonthlySubmitButton'
import NoticeList from '@!/User/Payment/components/MonthlyCourse/NoticeList'
import CardImage from '@images/card.webp'
import DocomoImage from '@images/docomo.webp'
import AuImage from '@images/au.webp'
// PayPay決済が審査未通過のため、決済方法選択肢から一時的に除外している。
// 再有効化時は下記 import と payTypes 配列の paypay 行のコメントを解除する。
// import PaypayImage from '@images/paypay.webp'

const payTypes = [
  { name: 'credit', image: CardImage },
  { name: 'docomo', image: DocomoImage },
  { name: 'au', image: AuImage },
  // { name: 'paypay', image: PaypayImage },
]

const PayTypeItem = ({ payType, handleChangePayType }) => (
  <Box>
    <Link as={'button'} onClick={() => handleChangePayType(payType)}>
      <PayTypeContent payType={payType} />
    </Link>
  </Box>
)

export const PayTypeContent = ({ payType, showIcon = true }) => {
  const image = payTypes.find((m) => m.name === payType)?.image
  if (!image) return null

  return (
    <HStack borderRadius={'xl'} borderY={'1px'} borderColor={'gray.200'} boxShadow={'md'} py={3} px={4}>
      {showIcon && <Icon as={FaCheck} color={'gray.400'} w={'6%'} h={'full'} />}
      <Image src={buildAssetUrlString(image)} alt={payType} w={'94%'} />
    </HStack>
  )
}

// 前回の決済方法を使用する
export const LastPayTypeSelector = ({ payType, handleRegister, handleChangeCard, restore }) => {
  if (!payType) return null

  return (
    <Box w={'full'}>
      <Box bg={'gray.100'} px={4} py={2} mb={4} fontWeight={'bold'}>
        以前と同じ決済方法を使用する
      </Box>

      <VStack spacing={4} px={4}>
        {payType === 'credit' ? <CreditCardInfo handleChangeCard={handleChangeCard} /> : <PayTypeContent payType={payType} />}
        <MonthlySubmitButton handleSubmit={() => handleRegister(payType)} restore={restore} />
      </VStack>
    </Box>
  )
}

// 決済方法を変更する
export const PayTypeChangeSelector = ({ excludePayType, handleChangePayType }) => {
  const filtered = excludePayType ? payTypes.filter((m) => m.name !== excludePayType) : payTypes
  return (
    <Box w={'full'}>
      <Box bg={'gray.100'} px={4} py={2} mb={3} fontWeight={'bold'}>
        決済方法を変更する
      </Box>

      <VStack px={4} spacing={3}>
        {filtered.map((payType) => (
          <PayTypeItem key={payType.name} payType={payType.name} handleChangePayType={handleChangePayType} />
        ))}
      </VStack>
    </Box>
  )
}

// 決済方法を選択する
export const PayTypeSelector = ({ handleRegister, handleChangePayType, pageBack, lastMonthlyCoursePayTypeCookie, currentCard, handleChangeCard, restore }) => {
  // 前回の決済方法を使用、またはカード情報があれば前回の決済方法にクレジットカードを設定。
  let lastPayType = lastMonthlyCoursePayTypeCookie
  if (isBlank(lastPayType)) {
    lastPayType = !isBlank(currentCard) ? 'credit' : null
  } else if (lastPayType === 'credit' && isBlank(currentCard)) {
    lastPayType = null
  }

  return (
    <VStack maxW={'600px'} m={'auto'} spacing={6}>
      <Box w={'full'} px={4}>
        <PaymentHeader />
      </Box>
      {!isBlank(lastPayType) ? (
        <>
          <LastPayTypeSelector payType={lastPayType} handleRegister={handleRegister} handleChangeCard={handleChangeCard} restore={restore} />
          <PayTypeChangeSelector excludePayType={lastPayType} handleChangePayType={handleChangePayType} />
        </>
      ) : (
        <Box w={'full'}>
          <Box bg={'gray.100'} px={4} py={2} mb={3} fontWeight={'bold'}>
            決済方法を選択してください
          </Box>

          <VStack spacing={3} px={4}>
            {payTypes.map((payType) => (
              <PayTypeItem key={payType.name} payType={payType.name} handleChangePayType={handleChangePayType} />
            ))}
          </VStack>
        </Box>
      )}
      <NoticeList restore={restore} />
      <PageBackLink pageBack={pageBack} />
    </VStack>
  )
}
